import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import ProcessorRuleDetails from 'components/ProcessorRule/Details';

const ScreenProcessorRuleDetails = ({ match, routePaths, target }) => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={6}>
      <ProcessorRuleDetails
        id={match.params.id}
        routePaths={routePaths}
        target={target}
      />
    </GridItem>
  </GridContainer>
);

ScreenProcessorRuleDetails.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
};

ScreenProcessorRuleDetails.defaultProps = {
  routePaths: undefined,
  target: undefined,
};

export default ScreenProcessorRuleDetails;
